import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getTermsAndConditions } from "../../../../services/packageService";
import Toster from "../../../common/Toster";
import TinyEditor from "../../../Editor/TinyEditor";
import { pbEditorWrap, pbEmptyState } from "../packageBuilderUi";

const TermsAndCondition = ({
  setTermsConditionData,
  packageid,
  readOnly,
  packageData,
  onUserEdit,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [error] = useState("");
  const [successMessage] = useState("");
  const [content, setContent] = useState("");
  const [hasServerData, setHasServerData] = useState(false);

  const { data: termsData, isLoading } = useQuery({
    queryKey: ["termsAndConditions", packageid],
    queryFn: () => getTermsAndConditions(packageid),
    enabled: !readOnly && !!packageid,
    retry: false,
    staleTime: 60_000,
  });

  const serverTerms = termsData?.data?.terms_and_conditions ?? "";
  const readOnlyTerms =
    packageData?.terms_and_conditions ??
    packageData?.data?.terms_and_conditions ??
    "";
  const editorValue = content || serverTerms;

  useEffect(() => {
    if (!packageid || readOnly) return;

    if (serverTerms) {
      setContent(serverTerms);
      setHasServerData(true);

      if (setTermsConditionData) {
        setTermsConditionData({
          terms_and_conditions: serverTerms,
          isUpdate: true,
        });
      }
    } else if (!isLoading && setTermsConditionData) {
      setHasServerData(false);
      setTermsConditionData({
        terms_and_conditions: "",
      });
    }
  }, [serverTerms, isLoading, setTermsConditionData, packageid, readOnly]);

  const handleEditorChange = (newContent) => {
    onUserEdit?.();
    setContent(newContent);

    if (setTermsConditionData) {
      setTermsConditionData({
        terms_and_conditions: newContent || "",
        isUpdate: hasServerData,
      });
    }
  };

  if (readOnly) {
    return (
      <div className="p-0">
        <h2 className="mb-4 text-sm font-bold text-gray-900">
          Terms and Conditions
        </h2>
        {readOnlyTerms ? (
          <div
            className="rounded-xl border border-gray-100 bg-slate-50/40 p-4 text-sm font-medium text-gray-800"
            dangerouslySetInnerHTML={{ __html: readOnlyTerms }}
          />
        ) : (
          <p className="py-8 text-center text-sm text-gray-500">
            No terms and conditions available
          </p>
        )}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={pbEmptyState}>
        Loading terms and conditions...
      </div>
    );
  }

  return (
    <>
      {showError && error && (
        <Toster
          message={error}
          type="error"
          duration={3000}
          onClose={() => setShowError(false)}
        />
      )}
      {showSuccess && successMessage && (
        <Toster
          message={successMessage}
          type="success"
          duration={3000}
          onClose={() => setShowSuccess(false)}
        />
      )}

      <div className="space-y-3">
        <label className="block text-sm font-medium text-gray-700">
          Description <span className="text-red-500">*</span>
        </label>
        <div className={pbEditorWrap}>
          <TinyEditor
            key={`package-terms-${packageid}-${editorValue ? "ready" : "empty"}`}
            className="package-field-text"
            value={editorValue}
            onChange={handleEditorChange}
            height={400}
          />
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;
